import Results from './Results.js';
export default Results;
